import { useState } from "react";

export const useRender = () => {
  const [counter, setCounter] = useState(0);
  return () => {
    setTimeout(() => {
      const newValue = counter + 1;
      setCounter(newValue);
    });
  };
};
